<template>
  <div id="MyPage">
    <Header/>
    <!-- {{data}} -->
    <!-- <div class="text-break primary" v-for="(item, index) in data" :key="index" style="vertical-align: baseline;">
      <div class="image" >
        <p class="SvgImage"><img v-bind:src="item.image" style="display: block; margin: auto;"></p>
      </div>
    </div> -->

    <!-- <div>
      <h1> Account details </h1>
    </div> -->
    <div class="text" v-if="!is_ethereum">
        <p>
          Please connect your ethereum wallet.
        </p>
        <p style="text-align: center; color: red">
          (This is the alpha version on Ethereum testnet Rinkeby).
        </p>

    </div>

    <div class="container-fluid mylife" v-if="is_ethereum">
      <div class="row all-display">
        <h3 class="label"><b> {{ data.length }} LIFEs owned by you: </b></h3>
        <div class="col-sm-5 col-md-4 col-lg-3 text-break primary" v-for="(item, index) in data" :key="index" style="vertical-align: baseline;">
          <div class="item rounded">
            <p><b>{{ item.name }}</b></p>
          <div class="image" >
            <router-link :to="{name: 'Detail', query: {id: item.index}}">
              <p class="SvgImage"><img v-bind:src="item.image" style="display: block; margin: auto;"></p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Footer/>
  </div>

</template>


<script>
import Web3Util from "../web3_util.js"
import db from "../firebase.js"
import Header from "./Header.vue"
import Footer from "./Footer.vue"

export default {
  name: 'MyPage',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      data: [],
      address: null,
      is_ethereum: false
    }
  },
  mounted: async function () {

    let accounts = await ethereum.request({ method: 'eth_accounts' });
    this.address = web3.utils.toChecksumAddress(accounts[0])
    // console.log(accounts[0])
    console.log(this.address)
    // console.log("0x3615ae16ea2ece2840194a07044567ba6862a50c")
    // let test = "0x646101A558FD11B7426176248964272D296c0Ee7"

    db.collection("info")
      .where("owner", "==", this.address)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          // console.log(`${doc.id} => ${doc.data().image}`)
          this.data.push(doc.data())
        })
      })
    this.is_ethereum = await Web3Util.load();
  },

  methods: {
    getOwnedLifes: function (event, address) {
      console.log(address)
      Web3Util.deposit(address, this.txtInput);//133238529999900
      // if (event) {
      //   alert(event.target.tagName)
      // }
    },
  },
  // mounted: async function(){
  //   console.log("mounted")//デバッグ用
  //   // this.items = await poke()
  // },
}

</script>

<style>
#list {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 40px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.all-display .col-md-3 {
  padding: 10px 10px;
  text-align: left;
}

.all-display .col-md-2 {
  padding: 10px 10px;
  text-align: left;
}

.all-display {
  margin: 0px 5px;
  text-align: left;
}

.item {
  padding: 10px 15px;
  border: 1px solid #000000;
  border-color: rgb(200,200,200,.7);
  /* height: 300px; */
  /* width: 100%; */
  /* height: auto; */
}

.image {
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: initial;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 100%;
  height: 250px;
}

.SvgImage img{
  height: auto;
  max-height: 250px;
  max-width: 100%;
  width:100%;
}

.mylife {
  text-align: center;
  padding: 10% 10%;
}

@media screen and(max-width: 600px) {
  .text {
    padding: 10% 15%;
    font-size: 10px;
  }
}

.text {
  padding: 150px 10%;
  font-size: 24px
}

</style>



// WEBPACK FOOTER //
// src/components/MyPage.vue